module.exports = __webpack_public_path__ + "static/media/(DH)-Prata-01.9175dc6b.jpg";